import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import _cloneDeep from 'lodash/cloneDeep';
import MenuItem from '@mui/material/MenuItem';
import { comparisonParams, filterParams } from '../../../utils/segments';
import { addQueryParams } from '../../../utils/browser';
import _pick from 'lodash/pick';
import ReduxStore from 'src/types/store/reduxStore';
import { CategoryEntity } from 'sl-api-connector';

const mapStateToProps = (state: ReduxStore) =>
  _pick(state, ['app', 'categories', 'entityService', 'retailer', 'mainTimePeriod']);

type Props = ReturnType<typeof mapStateToProps> &
  RouteComponentProps & {
    searchText: string;
    togglePanel?: () => {};
  };

class Categories extends React.Component<Props> {
  public state: {
    categories: CategoryEntity[];
  } = { categories: [] };

  componentWillMount() {
    const { categories, entityService } = this.props;
    const allCategories = _cloneDeep(categories);
    const categoriesToUse = [];
    allCategories.sort(
      (a, b) => (b as any).relevancyScore - (a as any).relevancyScore || a.categoryName.localeCompare(b.categoryName)
    );
    allCategories.forEach((val) => {
      if (
        entityService.mainEntity.type === 'category' ||
        entityService.mainEntity.categoryIds.indexOf(val.categoryId) !== -1
      ) {
        categoriesToUse.push(val);
      }
    });
    this.setState({ categories: categoriesToUse });
  }

  componentWillReceiveProps(nextProps) {
    const { searchText, categories } = nextProps;

    const categoriesToUse = categories.filter(
      (val) => val.categoryName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    this.setState({
      categories: categoriesToUse
    });
  }

  handleTouchTap = (selection) => {
    const { togglePanel, location, retailer, mainTimePeriod } = this.props;
    const entity = {
      id: selection.categoryId,
      type: 'category'
    };

    const existingParams = addQueryParams(location, retailer, mainTimePeriod, [...filterParams, ...comparisonParams]);

    togglePanel();
    this.props.history.push(`?ctype=${entity.type}&cid=${entity.id}&${existingParams}`);
  };

  showNoCategories() {
    const { categories } = this.state;

    if (categories.length > 0) {
      return null;
    }

    return <div style={{ padding: '10px' }}>No categories found.</div>;
  }

  render() {
    const { categories } = this.state;
    return (
      <div style={{ padding: '10px' }}>
        {categories.map((val) => (
          <MenuItem key={val.categoryId} style={{ fontSize: '14px' }} onClick={() => this.handleTouchTap(val)}>
            {val.categoryName}
          </MenuItem>
        ))}
        {this.showNoCategories()}
      </div>
    );
  }
}

export default withRouter(connect((state) => state)(Categories));
